import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { actions as aprobacionActions, selectors as aprobacionSelectors } from '../../reducers/aprobaciones';

const VotarAprobacionModal = ({
    show,
    onHide,
    solicitud,
    proyectoId,
    tipoVoto, // 'APROBADO' o 'RECHAZADO'
    onSuccess,
}) => {
    const dispatch = useDispatch();
    const isLoading = useSelector(aprobacionSelectors.getIsLoading);
    const [comentario, setComentario] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    const esAprobacion = tipoVoto === 'APROBADO';

    const handleConfirmar = (e) => {
        e.preventDefault();
        setErrorMsg('');

        if (!esAprobacion && (!comentario || !comentario.trim())) {
            setErrorMsg('Debe ingresar un comentario explicando el motivo del rechazo.');
            return;
        }

        const payload = {
            voto: tipoVoto,
            comentario: comentario ? comentario.trim() : null,
        };

        dispatch(aprobacionActions.votarAprobacion(solicitud.id, payload, proyectoId, (data) => {
            setComentario('');
            if (onSuccess) onSuccess(data);
            onHide();
        }));
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton className={esAprobacion ? 'bg-success text-white' : 'bg-danger text-white'}>
                <Modal.Title className="d-flex align-items-center h5 mb-0">
                    <i className={`bi ${esAprobacion ? 'bi-check2-circle' : 'bi-x-octagon'} me-2 fs-4`}></i>
                    {esAprobacion ? 'Confirmar Aprobación (Visto Bueno)' : 'Confirmar Rechazo de Solicitud'}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleConfirmar}>
                <Modal.Body className="p-4">
                    <div className="mb-3">
                        <h6 className="fw-bold mb-1">{solicitud && solicitud.titulo}</h6>
                        <small className="text-muted d-block">
                            Módulo: <span className="text-uppercase fw-bold">{solicitud && solicitud.modulo_tipo}</span>
                        </small>
                    </div>

                    <Alert variant={esAprobacion ? 'success' : 'warning'}>
                        <i className={`bi ${esAprobacion ? 'bi-info-circle' : 'bi-exclamation-triangle'} me-2`}></i>
                        {esAprobacion
                            ? '¿Está seguro de emitir su Visto Bueno para esta solicitud? Su firma quedará registrada con fecha y hora inmutable.'
                            : '¿Está seguro de RECHAZAR esta solicitud? Al rechazar, el flujo se detendrá inmediatamente y se notificará por correo a todos los involucrados.'
                        }
                    </Alert>

                    {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold">
                            {esAprobacion ? 'Comentarios / Observaciones (Opcional)' : 'Motivo del Rechazo (Obligatorio)'}
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            required={!esAprobacion}
                            placeholder={esAprobacion ? 'Ingrese comentarios opcionales sobre su aprobación...' : 'Explique detalladamente las razones u observaciones para que se realicen los ajustes...'}
                            value={comentario}
                            onChange={e => setComentario(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide} disabled={isLoading}>
                        Cancelar
                    </Button>
                    <Button
                        variant={esAprobacion ? 'success' : 'danger'}
                        type="submit"
                        disabled={isLoading}
                    >
                        {isLoading && <Spinner animation="border" size="sm" className="me-2" />}
                        {esAprobacion ? 'Confirmar Aprobación' : 'Confirmar Rechazo'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default VotarAprobacionModal;
